export const TableHelpers = {
    data() {
        return {
            tableColumns: [{
                    title: this.$t('area'),
                    type: 'custom-html',
                    key: 'accreditation_area',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: this.$t('activity'),
                    type: 'custom-html',
                    key: 'accreditation_activity',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: this.$t('type'),
                    type: 'custom-html',
                    key: 'accreditation_type',
                    modifier: (value) => {
                        return value.name;
                    }
                },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}